import { RootState } from "@redux/store";
import { useSelector } from "react-redux";

export const useAppSelector = <T>(selector: (state: RootState) => T) =>
  useSelector((state: RootState) => selector(state));
